var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _radialGradient5, _linearGradient48, _radialGradient6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 450.4 512",
    height: 512,
    viewBox: "0 0 450.4 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7da1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3104,
    stopColor: "#6d6f93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8987,
    stopColor: "#494c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.191,
    x2: 279.368,
    xlinkHref: "#lg1",
    y1: 3.009,
    y2: 510.377
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1a4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1a4c7",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.151,
    x2: 28.47,
    xlinkHref: "#lg2",
    y1: 13.62,
    y2: 25.7
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32365c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32365c",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-1 0 0 1 -11491.3 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -11794.209,
    x2: -11765.446,
    xlinkHref: "#lg3",
    y1: 11.204,
    y2: 27.105
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-1 0 0 -1 -11491.3 -12758.105)",
    gradientUnits: "userSpaceOnUse",
    x1: -11780.148,
    x2: -11758.389,
    y1: -13266.035,
    y2: -13241.404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a2d4d",
    stopOpacity: 0
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-1 0 0 -1 -11491.3 -12966.859)",
    gradientUnits: "userSpaceOnUse",
    x1: -11641.227,
    x2: -11641.227,
    y1: -13478.461,
    y2: -13462.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292c4d",
    stopOpacity: 0
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.11,
    x2: 32.651,
    xlinkHref: "#lg2",
    y1: 520.65,
    y2: 482.889
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 1 -11491.3 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -11790.059,
    x2: -11772.222,
    xlinkHref: "#lg3",
    y1: 256,
    y2: 256
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg2",
    y1: -2.637,
    y2: 16.054
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.096,
    x2: 19.691,
    xlinkHref: "#lg2",
    y1: 256,
    y2: 256
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4cbff"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.36,
    x2: 270.149,
    xlinkHref: "#lg4",
    y1: 21.028,
    y2: 492.259
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000187801,
    stopColor: "#a1b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b3ff",
    stopOpacity: 0
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.11,
    x2: 259.188,
    xlinkHref: "#lg5",
    y1: 256,
    y2: 256
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg5",
    y1: 492.032,
    y2: 473.554
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000211276,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.09,
    x2: 40.429,
    xlinkHref: "#lg6",
    y1: 256,
    y2: 256
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg6",
    y1: 20.413,
    y2: 36.444
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg1",
    y1: 460.247,
    y2: 480.737
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9093bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1833,
    stopColor: "#898cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4669,
    stopColor: "#75789f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8134,
    stopColor: "#56597c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg7",
    y1: 464.891,
    y2: 475.773
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg1",
    y1: 31.258,
    y2: 57.954
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.927,
    x2: 149.927,
    xlinkHref: "#lg7",
    y1: 34.05,
    y2: 53.865
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.094,
    x2: 117.094,
    xlinkHref: "#lg1",
    y1: 35.6,
    y2: 49.558
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.094,
    x2: 117.094,
    xlinkHref: "#lg7",
    y1: 38.115,
    y2: 49.856
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.715,
    x2: 118.582,
    y1: 41.402,
    y2: 44.801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8bad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1478,
    stopColor: "#b0b2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    stopColor: "#9a9dbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6572,
    stopColor: "#777999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#46496a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9093bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.455,
    x2: 299.764,
    xlinkHref: "#lg8",
    y1: 169.87,
    y2: 169.87
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -1.434,
    x2: 3.773,
    xlinkHref: "#lg8",
    y1: 164.811,
    y2: 164.811
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.734,
    x2: 337.309,
    y1: 254.002,
    y2: 398.002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1854,
    stopColor: "#a1b3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8466,
    stopColor: "#a1b3ff",
    stopOpacity: 0
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7da1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.509,
    x2: 260.509,
    xlinkHref: "#lg9",
    y1: 139.646,
    y2: 391.097
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.373,
    x2: 116.519,
    xlinkHref: "#lg2",
    y1: 234.165,
    y2: 246.192
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-1 0 0 1 -11360.838 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -11801.482,
    x2: -11765.337,
    xlinkHref: "#lg2",
    y1: 234.165,
    y2: 246.192
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.464,
    x2: 170.464,
    xlinkHref: "#lg9",
    y1: 191.561,
    y2: 260.041
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.806,
    x2: 348.806,
    y1: 152.157,
    y2: 275.486
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7da1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#626487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.509,
    x2: 260.509,
    xlinkHref: "#lg9",
    y1: 240.336,
    y2: 257.535
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.213,
    x2: 279.213,
    xlinkHref: "#lg9",
    y1: 197.442,
    y2: 224.791
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.804,
    x2: 241.804,
    xlinkHref: "#lg9",
    y1: 197.442,
    y2: 224.791
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.464,
    x2: 170.464,
    xlinkHref: "#lg4",
    y1: 185.944,
    y2: 254.424
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 348.806,
    cy: 193.577,
    fx: 348.66,
    fy: 189.185,
    gradientUnits: "userSpaceOnUse",
    r: 12.666
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffed81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7079,
    stopColor: "#ff8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7593,
    stopColor: "#ff8b08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8132,
    stopColor: "#ff9615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8681,
    stopColor: "#ffa62a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9238,
    stopColor: "#ffbe47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9795,
    stopColor: "#ffdc6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe97c"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_35_",
    cx: 348.806,
    cy: 243.599,
    fx: 348.813,
    fy: 239.748,
    gradientUnits: "userSpaceOnUse",
    r: 12.697
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#c8e458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2572,
    stopColor: "#b5d75a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4386,
    stopColor: "#95c15c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6408,
    stopColor: "#69a45e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7588,
    stopColor: "#4c9060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#509260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8471,
    stopColor: "#5b9a5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    stopColor: "#6da65e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#87b85c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9657,
    stopColor: "#a9ce5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cde758"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_36_",
    cx: 373.817,
    cy: 218.588,
    fy: 215.211,
    gradientUnits: "userSpaceOnUse",
    r: 12.422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7f5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1202,
    stopColor: "#ff7957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2805,
    stopColor: "#ff684a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4636,
    stopColor: "#ff4c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#ff2615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7776,
    stopColor: "#ff0c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7d5a"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_37_",
    cx: 323.794,
    cy: 218.588,
    fx: 323.848,
    fy: 214.354,
    gradientUnits: "userSpaceOnUse",
    r: 12.739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7809,
    stopColor: "#1c83ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8157,
    stopColor: "#2186ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8565,
    stopColor: "#2f90ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9003,
    stopColor: "#47a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9462,
    stopColor: "#68b6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9933,
    stopColor: "#91d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98d7ff"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.509,
    x2: 260.509,
    y1: 235.646,
    y2: 252.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c83ff"
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg10"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7f5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1546,
    stopColor: "#ff7957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3607,
    stopColor: "#ff684a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5962,
    stopColor: "#ff4c33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8514,
    stopColor: "#ff2615"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0c00"
  }))), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.213,
    x2: 279.213,
    xlinkHref: "#lg10",
    y1: 192.753,
    y2: 220.102
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.804,
    x2: 241.804,
    xlinkHref: "#lg10",
    y1: 192.753,
    y2: 220.102
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg11"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7da1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08845216,
    stopColor: "#66688b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1915,
    stopColor: "#56587a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3199,
    stopColor: "#4a4d6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#444768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424566"
  }))), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.588,
    x2: 310.588,
    xlinkHref: "#lg11",
    y1: 243.306,
    y2: 323.927
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg12"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b7da1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6981,
    stopColor: "#424566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7882,
    stopColor: "#454869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8648,
    stopColor: "#4f5274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9362,
    stopColor: "#606385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76799c"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_42_",
    cx: 310.355,
    cy: 298.938,
    fx: 310.491,
    fy: 291.859,
    gradientUnits: "userSpaceOnUse",
    r: 30.414,
    xlinkHref: "#lg12"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.473,
    x2: 210.473,
    xlinkHref: "#lg11",
    y1: 236.412,
    y2: 347.245
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_44_",
    cx: 210.662,
    cy: 298.938,
    fx: 210.798,
    fy: 291.859,
    gradientUnits: "userSpaceOnUse",
    r: 30.414,
    xlinkHref: "#lg12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.5 512c-26.6 0-48.2-21.6-48.2-48.2v-415.6c0-26.6 21.6-48.2 48.2-48.2h196.9c26.6 0 48.2 21.6 48.2 48.2v415.7c0 26.6-21.6 48.2-48.2 48.2h-196.9z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m70.1 66.4v-66.4h-18.6c-26.6 0-48.2 21.6-48.2 48.2v18.3h66.8z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.7 66.4v-66.4h18.6c26.6 0 48.2 21.6 48.2 48.2v18.3h-66.8z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.7 445.6v66.4h18.6c26.6 0 48.2-21.6 48.2-48.2v-18.3h-66.8z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.3 461.5v2.3c0 26.6 21.6 48.2 48.2 48.2h196.9c26.6 0 48.2-21.6 48.2-48.2v-2.3z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.1 445.6v66.4h-18.6c-26.6 0-48.2-21.6-48.2-48.2v-18.3h66.8z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.9 5.1c15.7 7.9 26.6 24.2 26.6 43v415.7c0 18.8-10.8 35.1-26.6 43z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.5 50.5v-2.3c0-26.6-21.6-48.2-48.2-48.2h-196.8c-26.6 0-48.2 21.6-48.2 48.2v2.3z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.9 5.1c-15.7 7.9-26.6 24.3-26.6 43.1v415.7c0 18.8 10.8 35.1 26.6 43z",
    fill: "url(#SVGID_9_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m276.7 463.8c0 15.7-12.7 28.3-28.3 28.3h-196.9c-15.7 0-28.3-12.7-28.3-28.3v-415.6c0-15.7 12.7-28.3 28.3-28.3h196.9c15.7 0 28.3 12.7 28.3 28.3z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m248.4 19.8h-14.4v472.4h14.3c15.7 0 28.3-12.7 28.3-28.3v-415.7c.1-15.7-12.6-28.4-28.2-28.4z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.2 455.4v8.5c0 15.7 12.7 28.3 28.3 28.3h196.9c15.7 0 28.3-12.7 28.3-28.3v-8.5z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.5 492.2h14.3v-472.4h-14.3c-15.7 0-28.3 12.7-28.3 28.3v415.7c0 15.7 12.6 28.4 28.3 28.4z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.7 64.4v-16.2c0-15.7-12.7-28.3-28.3-28.3h-196.9c-15.7 0-28.3 12.7-28.3 28.3v16.2z",
    fill: "url(#SVGID_14_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m197.4 476.5h-94.9c-3.5 0-6.3-2.8-6.3-6.3s2.8-6.3 6.3-6.3h94.9c3.5 0 6.3 2.8 6.3 6.3s-2.8 6.3-6.3 6.3z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.5 473.5c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4h94.9c1.9 0 3.4 1.5 3.4 3.4s-1.5 3.4-3.4 3.4z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m183.2 53.6h-66.5c-6.4 0-11.5-5.2-11.5-11.5 0-6.4 5.2-11.5 11.5-11.5h66.5c6.4 0 11.5 5.2 11.5 11.5 0 6.4-5.2 11.5-11.5 11.5z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.7 50.7c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6h66.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 117.1,
    cy: 42.1,
    fill: "url(#SVGID_19_)",
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.1,
    cy: 42.1,
    fill: "url(#SVGID_20_)",
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.1,
    cy: 42.1,
    fill: "url(#SVGID_21_)",
    r: 0.6
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m296.6 140-.1 59.7h.1c1.8 0 3.3-1.5 3.3-3.3v-53.1c0-1.8-1.5-3.3-3.3-3.3z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.3 162.8v-32.9c-1.8 0-3.3 1.5-3.3 3.3v26.2c0 1.9 1.5 3.4 3.3 3.4zm0 36.9v-32.9c-1.8 0-3.3 1.5-3.3 3.3v26.2c0 1.9 1.5 3.4 3.3 3.4z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m260.5 152.6c-23.3 0-45.8-3.4-67-9.8-23-6.9-48.2-.3-64.6 17.2-7.4 7.9-13.1 17.5-16.6 28.3l-39.6 125.5c-5.8 18.2.7 36.6 13.9 47.6 1.1 1.3 78.3 78.6 130.5 130.7h31.3c15.6 0 28.3-12.7 28.3-28.4v-311.7c-5.4.4-10.8.6-16.2.6z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m448.3 313.8-39.7-125.5c-3.6-11.4-9.8-21.5-17.9-29.7-16.4-16.7-40.9-22.6-63.3-15.9-21.2 6.4-43.7 9.8-67 9.8s-45.8-3.4-67-9.8c-23-6.9-48.1-.3-64.6 17.2-7.4 7.9-13.1 17.5-16.6 28.3l-39.5 125.6c-9.1 28.8 12.4 58.1 42.6 58.1 11.8 0 23.1-4.7 31.5-13l36.2-36.1c49.9-43.6 118-37.9 155.1 0l36.2 36.1c8.4 8.3 19.7 13 31.5 13 30.1 0 51.6-29.3 42.5-58.1z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m128.9 160c-7.4 7.9-13.1 17.5-16.6 28.3l-39.6 125.5c-9.1 28.8 12.4 58.1 42.6 58.1 4.4 0 8.8-.7 13-1.9-22.9-7-37.2-31.8-29.5-56.2l39.7-125.5c3.4-10.8 9.2-20.4 16.6-28.3 9-9.6 20.7-16 33.2-18.6-21.6-4.4-44.2 2.4-59.4 18.6z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.1 160c7.4 7.9 13.1 17.5 16.6 28.3l39.7 125.5c9.1 28.8-12.4 58.1-42.6 58.1-4.4 0-8.8-.7-13-1.9 22.9-7 37.2-31.8 29.5-56.2l-39.7-125.5c-3.4-10.8-9.2-20.4-16.6-28.3-9-9.6-20.7-16-33.2-18.6 21.5-4.4 44.1 2.4 59.3 18.6z",
    fill: "url(#SVGID_27_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194 212.3h-8.7c-1.6 0-3-1.3-3-3v-8.7c0-6.4-5.2-11.6-11.6-11.6h-.5c-6.4 0-11.6 5.2-11.6 11.6v8.7c0 1.6-1.3 3-3 3h-8.6c-6.4 0-11.6 5.2-11.6 11.6v.5c0 6.4 5.2 11.6 11.6 11.6h8.7c1.6 0 3 1.3 3 3v8.7c0 6.4 5.2 11.6 11.6 11.6h.5c6.4 0 11.6-5.2 11.6-11.6v-8.7c0-1.6 1.3-3 3-3h8.7c6.4 0 11.6-5.2 11.6-11.6v-.4c-.1-6.4-5.3-11.7-11.7-11.7z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.7 199.2c0 6.5-5.3 11.9-11.9 11.9s-11.9-5.3-11.9-11.9c0-6.5 5.3-11.9 11.9-11.9s11.9 5.3 11.9 11.9zm-11.9 38.2c-6.5 0-11.9 5.3-11.9 11.9 0 6.5 5.3 11.9 11.9 11.9s11.9-5.3 11.9-11.9-5.3-11.9-11.9-11.9zm36.9-13.2c0-6.5-5.3-11.9-11.9-11.9s-11.9 5.3-11.9 11.9 5.3 11.9 11.9 11.9 11.9-5.3 11.9-11.9zm-50 0c0-6.5-5.3-11.9-11.9-11.9s-11.9 5.3-11.9 11.9 5.3 11.9 11.9 11.9 11.9-5.3 11.9-11.9z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m275.8 254.1h-30.6c-3.1 0-5.7-2.5-5.7-5.7 0-3.1 2.5-5.7 5.7-5.7h30.6c3.1 0 5.7 2.5 5.7 5.7 0 3.2-2.5 5.7-5.7 5.7z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m285.7 206-10.2-5.9c-1.8-1-4 .3-4 2.3v11.8c0 2.1 2.2 3.3 4 2.3l10.2-5.9c1.7-1 1.7-3.6 0-4.6z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.4 206 10.2-5.9c1.8-1 4 .3 4 2.3v11.8c0 2.1-2.2 3.3-4 2.3l-10.2-5.9c-1.8-1-1.8-3.6 0-4.6z",
    fill: "url(#SVGID_32_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m194 206.7h-8.7c-1.6 0-3-1.3-3-3v-8.7c0-6.4-5.2-11.6-11.6-11.6h-.5c-6.4 0-11.6 5.2-11.6 11.6v8.7c0 1.6-1.3 3-3 3h-8.6c-6.4 0-11.6 5.2-11.6 11.6v.5c0 6.4 5.2 11.6 11.6 11.6h8.7c1.6 0 3 1.3 3 3v8.7c0 6.4 5.2 11.6 11.6 11.6h.5c6.4 0 11.6-5.2 11.6-11.6v-8.7c0-1.6 1.3-3 3-3h8.7c6.4 0 11.6-5.2 11.6-11.6v-.5c-.1-6.4-5.3-11.6-11.7-11.6z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 348.8,
    cy: 193.6,
    fill: "url(#SVGID_34_)",
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.8,
    cy: 243.6,
    fill: "url(#SVGID_35_)",
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.8,
    cy: 218.6,
    fill: "url(#SVGID_36_)",
    r: 11.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.8,
    cy: 218.6,
    fill: "url(#SVGID_37_)",
    r: 11.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m275.8 249.4h-30.6c-3.1 0-5.7-2.5-5.7-5.7 0-3.1 2.5-5.7 5.7-5.7h30.6c3.1 0 5.7 2.5 5.7 5.7 0 3.2-2.5 5.7-5.7 5.7z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m285.7 201.3-10.2-5.9c-1.8-1-4 .3-4 2.3v11.8c0 2.1 2.2 3.3 4 2.3l10.2-5.9c1.7-1 1.7-3.6 0-4.6z",
    fill: "url(#SVGID_39_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.4 201.3 10.2-5.9c1.8-1 4 .3 4 2.3v11.8c0 2.1-2.2 3.3-4 2.3l-10.2-5.9c-1.8-1-1.8-3.6 0-4.6z",
    fill: "url(#SVGID_40_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m310.4 267.8c-15.3 0-28.1 11.1-30.6 25.7 20.6 3.2 39.6 12 54.4 25.5 4.6-5.4 7.4-12.4 7.4-20.1-.1-17.1-14.1-31.1-31.2-31.1z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.4,
    cy: 298.9,
    fill: "url(#SVGID_42_)",
    r: 26.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m242.2 294c-19.2 3.4-38.4 11.8-55.6 25.8-4.8-5.6-7.8-12.9-7.8-20.8 0-17.6 14.3-31.9 31.9-31.9 15.9 0 29.1 11.6 31.5 26.9z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.7,
    cy: 298.9,
    fill: "url(#SVGID_44_)",
    r: 26.6
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileGame);
export default __webpack_public_path__ + "static/media/mobile-game.30fa8d009fdce5502873b249bc84ec4a.svg";
export { ForwardRef as ReactComponent };